import { Component, OnInit } from '@angular/core';
import { CompoundNameCIF } from '../../../shared/viewmodels/UtilityObj';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';

@Component({
  selector: 'app-compund-name-owner',
  templateUrl: './compund-name-owner.component.html',
  styleUrls: ['./compund-name-owner.component.css']
})
export class CompundNameOwnerComponent implements OnInit {
  public utilityobj: CompoundNameCIF;
  message: any;
  public form: UntypedFormGroup;
  namePattern = "[a-zA-Z0-9&/+=,.';:@#()\\s\*\"-]*";

  constructor(private store: Store<AppState>, private fb: UntypedFormBuilder) {
    this.utilityobj = new CompoundNameCIF();
    this.store.select(getRegSearchState).subscribe(data => this.message = data
    );

    if (this.message.name[0]!=null) {
    console.log(this.message.name[0].lastcorpName);
    this.utilityobj.lastcorpName = this.message.name[0].lastcorpName;
    this.utilityobj.fName = this.message.name[0].fName;
    }
  }

  ngOnInit() {
    this.form = this.fb.group({
      'lastcorpName': [this.utilityobj.lastcorpName, [Validators.required, Validators.pattern(this.namePattern)]],
      'fName': [this.utilityobj.fName, [Validators.pattern(this.namePattern)]]
    });

    this.form.valueChanges.subscribe((value) => {
      if (this.form.valid) {
        this.utilityobj.lastcorpName = value.lastcorpName ? value.lastcorpName.toUpperCase() : '';
        console.log(`lastcorpName: ${this.utilityobj.lastcorpName}`);
        this.utilityobj.fName = value.fName ? value.fName.toUpperCase() : '';


      }
    });
  }

}
